import cx from 'classix'
import React from 'react'

type Props = {
  open: boolean
  hasSubmenuOpen?: boolean
  children: React.ReactNode
  className?: string
  translateLeftHidden?: boolean
}

export default function MobileMenuContainer({
  open,
  hasSubmenuOpen,
  children,
  className,
  translateLeftHidden = false,
}: Props) {
  return (
    <div
      className={cx(
        'absolute hide-scroll-bar top-20 left-0 transform duration-300 w-full overflow-auto px-5',
        className
      )}
      style={{
        transform: open
          ? hasSubmenuOpen
            ? 'translateX(-100%)'
            : 'translateX(0)'
          : translateLeftHidden
          ? 'translateX(-100%)'
          : 'translateX(100%)',
        bottom: '72px',
      }}
    >
      {children}
    </div>
  )
}
